import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import CreditsPage from "@/pages/CreditsPage.vue";
import DocPage from "@/pages/DocPage.vue";
import NotFoundPage from "@/pages/NotFoundPage.vue";
import WelcomePage from "@/pages/WelcomePage.vue";

const routes: RouteRecordRaw[] = [{
    component: WelcomePage,
    name: "home",
    path: "/home"
},{
    component: CreditsPage,
    name: "credits",
    path: "/credits"
},{
    component: DocPage,
    name: "docs",
    path: "/docs/:id?"
},{
    name: "root",
    path: "/",
    redirect: "/home"
},{
    component: NotFoundPage,
    path: "/:pathMatch(.*)*"
}];

export const router = createRouter({
    history: createWebHistory(),
    routes
});
